export default __webpack_public_path__ + "static/media/shamoonirfan.439fbb6f.jpg";